import { meGet } from '@services/api/backend';
import { useMutation } from '@/hooks/useApi';

export function useEndImpersonate() {
  return useMutation({
    mutationFn: async () => {
      const res = await meGet();
      return res.data;
    },
  });
}
